<template>
  <PageContainer>
    <PageHeader class="mb-6" :backButton="false">
      <template v-slot:title>Reports</template>
    </PageHeader>
    <Table
      :items="reports"
      :actions="actions"
      :hideColumns="['path']"
      :refresh="false"
    />
  </PageContainer>
</template>

<script>
import { TableAction } from "../../../components/tables/Table/TableAction";
export default {
  data() {
    return {
      reports: [
        {
          name: "Sales Report",
          path: "SRS_Sales",
        },
      ],
      actions: [
        new TableAction("View", {
          click: (report) => {
            this.$router.push("/app/reports/" + report.path);
            this.$store.commit("setCurrentReport", report.name);
          },
        }),
      ],
    };
  }, // data
  methods: {
    setCurrentReport(report) {
      this.$router.push("/app/reports/" + report.path);
      this.$store.commit("setCurrentReport", report.name);
    },
  },
};
</script>
